import { FC } from 'react';
import { useIsFrontendStyleDefault } from '@edikk-edikk/country-frontend';
import PhotoXsWebp from '#srcImages/main-background/style-default/photo-xs.webp';
import PhotoSmWebp from '#srcImages/main-background/style-default/photo-sm.webp';
import PhotoWebp from '#srcImages/main-background/style-default/photo.webp';
import { BackgroundImage } from '#home/components';

const BackgroundImageDefaultStyleDefault: FC = () => {
  const isFrontendStyleDefault = useIsFrontendStyleDefault();

  if (!isFrontendStyleDefault) {
    return null;
  }

  return (
    <picture>
      <source
        media="(max-width: 799px)"
        srcSet={`${PhotoXsWebp} 1x, ${PhotoSmWebp} 2x, ${PhotoWebp} 3x`}
      />
      <BackgroundImage src={PhotoWebp} />
    </picture>
  );
};

export { BackgroundImageDefaultStyleDefault };
